import apiClient from './client';
import type { MenuConfig } from '@/types';

export async function getMenuConfig(): Promise<MenuConfig> {
  const response = await apiClient.get<MenuConfig>('/api/menu-config');
  return response.data;
}
